import React from "react"

export default React.createContext({
  menuOptions: [],
  addMenuOption: () => null,
  updateMenuOptions: () => null,
  updateMenu: () => null,
})
